class PersonSelectionService {
    constructor() {
        'ngInject';

        this.groups = [];
        this.people = [];
        //this.config = StaffPriorities;//TODO !!!
    }

    /**
     * @description Checks if staff grouping is configured and returns a boolean
     *
     * @param None
     *
     * @return {Boolean} True if configured, false if not
     */
    isPeopleGroupConfigured() {
        if (this.config && Object.keys(this.config).length) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * @description Assigns people to PersonSelectionService
     * and sorts them into their appropriate groups
     *
     * @param {array} people - An array from the people API
     * @param {Object} service - A service object associated with the time data
     *
     * @return Void
     */
    setPeople(people, service) {
        this.people = people;
        this.setGroups(service.id);

        if (this.isPeopleGroupConfigured()) {
            this.groups.forEach((group) => {
                people.forEach((person) => {
                    if (!group.people) {
                        group.people = [];
                    }
                    if (person.group_name === group.name) {
                        group.people.push(person);
                    }
                });
            });

            return;
        }

        this.groups = [];
    }

    /**
     * @description Assigns groups to the service from parameter
     * or pre-configured groups
     *
     * @param {Number} service - Service id
     *
     * @return Void
     */
    setGroups(service) {
        if (this.isPeopleGroupConfigured()) {
            this.groups = this.config[service].peopleGroups;
        }
    }

    /**
     * @description Returns groups for matching priority
     *
     * @param {Number} priority - Priority to be searched
     *
     * @return {Object} A group object if exists
     */
    getGroupsByPriority(priority) {
        return this.groups.filter(group => group.priority === priority)[0];
    }

    /**
     * @description Returns the highest priority found within groups
     *
     * @param None
     *
     * @return {Number} highestPriorityFound - A number which represents
     * the highest priority found within groups
     */
    getHighestGroupPriority() {
        let highestPriorityFound;

        this.groups.forEach((group) => {
            if (
                group.priority < highestPriorityFound ||
                !highestPriorityFound
            ) {
                highestPriorityFound = group.priority;
            }
        });

        return highestPriorityFound;
    }

    /**
     * @description Returns the next available priority found within groups
     *
     * @param {Number} priority - A number value representing the priority level
     *
     * @return {Number} nextPriority - A number value representing
     * the next available priorty found within the groups
     */
    getNextPriority(priority) {
        let nextPriority;

        this.groups.forEach((group) => {
            if (group.priority > priority) {
                nextPriority = group.priority;
            }
        });

        return nextPriority;
    }

    /**
     * @description Returns a random person. If groups are configured,
     * the random person is selected from the highest priority available
     * set by the groups
     *
     * @param {Array} people - A person collection
     *
     * @return {person} A randomly selected person
     */
    getRandomPerson(people) {
        return people[Math.floor(Math.random() * people.length)];
    }

    /**
     * @description Used to filter an array of people
     *
     * @param {String} personName - Name of the person
     *
     * @return {Array} A person if exists
     */
    filterPeopleByPerson(personName) {
        return this.people.filter(person => person.name === personName)[0];
    }

    /**
     * @description It takes a specific priority and return corresponding people
     *
     * @param {Number} priority - A number value representing the priority level
     *
     * @return {Array} A persons collection
     */
    getPeopleByPriority(priority) {
        const group = this.getGroupsByPriority(priority);
        const people = group.people;

        return people.map(person => person.name);
    }

    /**
     * @description Returns persons that are available to a specific time
     * from the highest group priority
     *
     * @param {Array} eventPeople - An array with people for a specific time event
     * @param {Number} priority - A number value representing the priority level
     *
     * @return {Array} A filtered person collection by availability
     */
    getAvailablePeople(eventPeople, priority) {
        if (!priority) {
            priority = this.getHighestGroupPriority();
        }

        const peopleToTest = this.getPeopleByPriority(priority);
        const availablePeople = eventPeople.filter(person =>
            peopleToTest.includes(person)
        );

        if (availablePeople.length) {
            return availablePeople;
        }

        return this.getAvailablePeople(eventPeople, this.getNextPriority(priority));
    }
}

const personSelectionService = new PersonSelectionService();

export {
    personSelectionService
}